import { Injectable } from '@angular/core';
import { has } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setSessionToken() {
    // localStorage.setItem('storedAuth', JSON.stringify({
    //   storedAuth: "H4EMxZw/FhZlnDuzpzACZqv0ua3KaRMQjApkHirHphE=",
    //   authData: {
    //     hash: "7WOYAMGHiY9XW4pxBOPipAcjwuX4ZIzz9exaLYWvm6w=",
    //     email: "henry.lora@lacolonial.com.do"
    //   }
    // }));
  }

  getSessionToken() {
    const raw = localStorage.getItem('authData');
    if (!raw) return null;
    const main = JSON.parse(raw);
    return {

      hash: main.hash,
      email: main.email
    };
  }


}
